import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { 申報通用解碼 } from "./GovRowParser_既往病史_自覺症狀";
import { HisBasic } from "./HisBasic";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class GovRowParser_生活習慣 {

  static ConvertToHisRow(func_guid: string, func_code: string, step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_生活習慣) {
      throw new Error("5984985 必須是 CHAPTER_生活習慣 !!!");
    }

    if (func_guid === SpwkUtilV3.A01_func_guid) {
      throw new_ErrorAlert("4684143 A01 還沒有轉申報格式 !!!")
    }

    let re: GovRow[] = [];

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_生活習慣);
    let A98Sleep: string = ''
    for (const q_meta of q_meta_list) {
      if (q_meta.q_gov_code == null || q_meta.q_gov_code === "") {
        if (func_guid === SpwkUtilV3.A98_func_guid) {//yao 27~30 48~56
          let input_meta_list = meta_table.FilterInputs_ByQuestionGuid(q_meta.question_guid);
          A98Sleep = input_meta_list[0].rhf_value
        }
        continue;  // pass; 目前不處理沒有指定申報代碼的題目
      }

      if (func_guid === SpwkUtilV3.B02_func_guid) {// 使用 B02 解碼規則
        const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
        if (gov_row.問題編號 === '01') {
          gov_row.問題編號 = '02';
        } else if (gov_row.問題編號 === '02') {
          gov_row.問題編號 = '03';
        } else if (gov_row.問題編號 === '03') {
          gov_row.問題編號 = '04';
        } else if (gov_row.問題編號 === '04') {
          gov_row.問題編號 = '01';
        } else {
          throw new_ErrorAlert('4794164' + '異常的gov_row.問題編號')
        }
        re.push(gov_row);
      } else if (func_guid === SpwkUtilV3.A98_func_guid) {
        const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
        if (gov_row.問題編號 === "01") {
          gov_row.答題內容 = '11'
          gov_row.答題內容_2 = gov_row.答題內容_1
          gov_row.答題內容_1 = A98Sleep
        }
        re.push(gov_row);
      }
      else {
        const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
        re.push(gov_row);
      }

    }
    re.sort((a, b) => a.問題編號.localeCompare(b.問題編號));
    return re;
  }

}
